module.exports = __webpack_public_path__ + "img/logo_istruct.7ea7a1a5.svg";